import {RunningTime} from '@hconnect/common/types'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {SxProps, Theme} from '@mui/material'
import moment from 'moment-timezone'
import {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

import {RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

import {OperationHoursContainer} from './OperationHoursContainer'

type Props = {
  plantId: string
  onEquipmentClick?: (equipmentId: string) => void
  renderRunningTimeTooltipFooter?: (rt: RunningTime) => ReactNode
  cardBoxSx?: SxProps<Theme>
  isMobile?: boolean
}

export const OperationHoursFromYesterdayContainer = ({
  plantId,
  onEquipmentClick,
  renderRunningTimeTooltipFooter,
  cardBoxSx,
  isMobile = false
}: Props) => {
  const {t} = useTranslation(RUNNING_TIMES_WIDGET_NAMESPACE)
  const timezone = useUpmPlantTimezone(plantId)
  const startOfYesterday = moment.utc().tz(timezone).subtract(1, 'day').startOf('day')
  const endOfToday = moment.utc().tz(timezone).endOf('day')

  return (
    <OperationHoursContainer
      plantId={plantId}
      from={startOfYesterday.toISOString()}
      to={endOfToday.toISOString()}
      timezone={timezone}
      clipToCurrentTime={true}
      timeRangeLabel={t('operationHours.label.fromYesterday')}
      onEquipmentClick={onEquipmentClick}
      renderRunningTimeTooltipFooter={renderRunningTimeTooltipFooter}
      cardBoxSx={cardBoxSx}
      isMobile={isMobile}
    />
  )
}
